import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FiMapPin, FiMail, FiPhone } from "react-icons/fi";
import { BsFillTriangleFill } from "react-icons/bs";
import { useTranslation } from "react-i18next";
import ScrollTop from "./ScrollTop";
import "./FooterTwo.css";

const FooterTwo = () => {
  const { t } = useTranslation();
  // Add Google Tag script
  useEffect(() => {
    const script1 = document.createElement("script");
    script1.async = true;
    script1.src = "https://www.googletagmanager.com/gtag/js?id=AW-16672072231";
    document.head.appendChild(script1);

    const script2 = document.createElement("script");
    script2.innerHTML = `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);} 
          gtag('js', new Date());
          gtag('config', 'AW-16672072231');
        `;
    document.head.appendChild(script2);

    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
    };
  }, []);

  return (
    <>
      <footer className="cy-footer">
        <div className="cy-footer-top">
          <div className="container">
            <div className="row gy-5">
              {/* Contact */}
              <div className="col-lg-4 col-md-6">
                <div className="cy-col cy-contact">
                  <h4 className="cy-title">Contact</h4>
                  <ul className="cy-list">
                    <li>
                      <FiMapPin className="cy-ic" />
                      <span>Address: 5/15 Field St, Adelaide SA 5000</span>
                    </li>
                    <li>
                      <FiMail className="cy-ic" />
                      <span>Email: info@cyberate.investments</span>
                    </li>
                    <li>
                      <FiPhone className="cy-ic" />
                      <span>Phone: +61 8 7110 0111</span>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Menu */}
              <div className="col-lg-4 col-md-6">
                <div className="cy-col cy-menu">
                  <h4 className="cy-title">Menu</h4>
                  <ul className="cy-links">
                    <li><BsFillTriangleFill className="cy-ic" /><Link to="/">Home</Link></li>
                    <li><BsFillTriangleFill className="cy-ic" /><Link to="/Service">Services</Link></li>
                    <li><BsFillTriangleFill className="cy-ic" /><Link to="/contact">Contact us</Link></li>
                    <li><BsFillTriangleFill className="cy-ic" /><Link to="/AboutUs">About us</Link></li>
                  </ul>
                </div>
              </div>

              {/* About */}
              <div className="col-lg-4">
                <div className="cy-col cy-about">
                  <h4 className="cy-title">About us</h4>
                  <div className="cy-about-logo">
                    <img src={`${process.env.PUBLIC_URL}/images/logo/logo-cyberate.png`} alt="Cyberate Investments" />
                  </div>
                  <p className="cy-about-text">{t("dddi.hero.tagline")}</p>
                  <p className="cy-about-text">
                    Cyberate Investments acknowledges the Traditional Owners and Custodians of the lands throughout Australia.
                    We pay our respects to Elders both past and present and honour the enduring cultural, spiritual, and educational
                    practices of Aboriginal and Torres Strait Islander peoples.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="cy-footer-bottom">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center cy-bottom-item" style={{ paddingBottom: 12, fontSize: 13, opacity: 0.85 }}>
                {t("dddi.footer.disclaimer")}
              </div>
            </div>
            <div className="row align-items-center">
              <div className="col-lg-4 col-md-4 text-center text-md-start cy-bottom-item">{t("dddi.footer.company")} · {t("dddi.footer.group")}</div>
              <div className="col-lg-4 col-md-4 text-center cy-bottom-item">Designed by <a href="https://cyberate.tech" target="_blank" rel="noreferrer">Cyberate Technologies</a></div>
              <div className="col-lg-4 col-md-4 text-center cy-bottom-item">V 1.0.0</div>
            </div>
          </div>
        </div>
      </footer>
      <ScrollTop />
    </>
  );
};

export default FooterTwo;
